<template>
    <v-row justify="center" data-app="true">
        <v-dialog v-model="registerFlag" :fullscreen="isMobile" max-width="480" persistent>
            <v-card class="login-container" style="border-radius:4px">
                <div @click="close" style="float: right;cursor: pointer;margin-bottom: 20px;">
                    <svg-icon style="width: 20px;height: 20px;" icon-class="close"></svg-icon>
                </div>
                <div class="login-wrapper">
                    <h3 style="text-align: center; margin-bottom: 30px;">账户注册</h3>
                    <!-- 邮箱号 -->
                    <v-text-field 
                        style="width: 100%;" 
                        v-model="username" 
                        label="邮箱号" 
                        placeholder="请输入您的邮箱号"
                        type="email"
                        :error-messages="emailErrors"
                        @input="validateEmail"
                        @keyup.enter="register" 
                    />
                    <!-- 昵称 -->
                    <v-text-field 
                        v-model="nickname" 
                        label="昵称" 
                        placeholder="请输入您的昵称"
                        :error-messages="nicknameErrors"
                        @input="validateNickname"
                        @keyup.enter="register" 
                    />
                    <!-- 验证码 -->
                    <div class="mt-7 send-wrapper">
                        <v-text-field 
                            maxlength="6" 
                            v-model="code" 
                            label="验证码" 
                            placeholder="请输入6位验证码"
                            type="text"
                            :error-messages="codeErrors"
                            @input="validateCode"
                            @keyup.enter="register" 
                        />
                        <v-btn text small :disabled="isCodeBtnDisabled" @click="sendCode" :loading="codeSending">
                            {{ codeMsg }}
                        </v-btn>
                    </div>
                    <!-- 密码 -->
                    <v-text-field 
                        v-model="password" 
                        class="mt-7" 
                        label="密码" 
                        placeholder="请输入您的密码（至少6位）"
                        type="password"
                        :error-messages="passwordErrors"
                        @input="validatePassword"
                        @keyup.enter="register" 
                    />
                    <!-- 密码确认 -->
                    <v-text-field 
                        v-model="confirmPassword" 
                        class="mt-7" 
                        label="确认密码" 
                        placeholder="请再次输入您的密码"
                        type="password"
                        :error-messages="confirmPasswordErrors"
                        @input="validateConfirmPassword"
                        @keyup.enter="register" 
                    />
                    <!-- 密码强度提示 -->
                    <div v-if="password" class="mt-2 password-strength">
                        <span :class="passwordStrengthClass">密码强度: {{ passwordStrength }}</span>
                    </div>
                    <!-- 注册按钮 -->
                    <v-btn 
                        class="mt-7" 
                        block 
                        style="color:#fff;background-color: red;margin-top: 10px;" 
                        @click="register"
                        :loading="isLoading"
                        :disabled="!isFormValid || isLoading"
                    >
                        注册
                    </v-btn>
                    <!-- 登录 -->
                    <div class="mt-10 login-tip">
                        已有账号？<span @click="openLogin">立即登录</span>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { sendEmailCode, emailRegister, emailLogin, checkEmailExists } from "@/api";

export default {
    data: function () {
        return {
            username: "",
            code: "",
            password: "",
            confirmPassword: "",
            nickname: "",
            isCodeBtnDisabled: true,
            codeSending: false,
            codeMsg: "发送验证码",
            time: 60,
            isLoading: false,
            // 验证错误信息
            emailErrors: [],
            codeErrors: [],
            passwordErrors: [],
            nicknameErrors: [],
            confirmPasswordErrors: [],
        };
    },
    methods: {
        openLogin() {
            this.$store.state.registerFlag = false;
            this.$store.state.loginFlag = true;
        },
        close() {
            this.$store.state.registerFlag = false;
            this.resetForm();
        },
        resetForm() {
            this.username = "";
            this.code = "";
            this.password = "";
            this.confirmPassword = "";
            this.nickname = "";
            this.emailErrors = [];
            this.codeErrors = [];
            this.passwordErrors = [];
            this.nicknameErrors = [];
            this.confirmPasswordErrors = [];
            this.time = 60;
            this.codeMsg = "发送验证码";
            this.isCodeBtnDisabled = true;
        },
        // 邮箱验证
        validateEmail() {
            this.emailErrors = [];
            if (!this.username) {
                this.emailErrors = ["请输入邮箱"];
                this.isCodeBtnDisabled = true;
                return false;
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const allowedDomains = ['gmail.com', 'outlook.com', 'hotmail.com', 'icloud.com', 'foxmail.com', 'qq.com', '163.com', '126.com'];
            const domain = this.username.toLowerCase().split('@').pop();
            if (!emailRegex.test(this.username)) {
                this.emailErrors = ["请输入正确的邮箱格式"];
                this.isCodeBtnDisabled = true;
                return false;
            }
            if (!allowedDomains.includes(domain)) {
                this.emailErrors = ["邮箱仅支持 gmail、outlook、hotmail、icloud、foxmail、qq、163、126"];
                this.isCodeBtnDisabled = true;
                return false;
            }
            this.isCodeBtnDisabled = false;
            return true;
        },
        // 验证码验证
        validateCode() {
            this.codeErrors = [];
            if (!this.code) {
                this.codeErrors = ["请输入验证码"];
                return false;
            }
            if (!/^\d{6}$/.test(this.code)) {
                this.codeErrors = ["验证码必须是6位数字"];
                return false;
            }
            return true;
        },
        // 密码验证
        validatePassword() {
            this.passwordErrors = [];
            if (!this.password) {
                this.passwordErrors = ["请输入密码"];
                return false;
            }
            if (this.password.length < 6) {
                this.passwordErrors = ["密码至少需要6位"];
                return false;
            }
            if (this.password.length > 20) {
                this.passwordErrors = ["密码最多20位"];
                return false;
            }
            // 验证确认密码匹配
            if (this.confirmPassword && this.password !== this.confirmPassword) {
                this.confirmPasswordErrors = ["两次密码不一致"];
            }
            return true;
        },
        // 确认密码验证
        validateConfirmPassword() {
            this.confirmPasswordErrors = [];
            if (!this.confirmPassword) {
                this.confirmPasswordErrors = ["请确认密码"];
                return false;
            }
            if (this.confirmPassword !== this.password) {
                this.confirmPasswordErrors = ["两次密码输入不一致"];
                return false;
            }
            return true;
        },
        // 昵称验证
        validateNickname() {
            this.nicknameErrors = [];
            if (!this.nickname) {
                this.nicknameErrors = ["请输入昵称"];
                return false;
            }
            if (this.nickname.length < 2) {
                this.nicknameErrors = ["昵称至少需要2个字符"];
                return false;
            }
            if (this.nickname.length > 20) {
                this.nicknameErrors = ["昵称最多20个字符"];
                return false;
            }
            return true;
        },
        // 发送验证码
        sendCode() {
            if (!this.validateEmail()) {
                return;
            }

            this.codeSending = true;
            sendEmailCode(this.username).then(res => {
                this.countDown();
                this.$toast({ type: "success", message: "验证码已发送到您的邮箱，请查收" });
            }).catch(err => {
                this.codeSending = false;
                this.$toast({ type: "error", message: err.message || "发送验证码失败，请重试" });
            });
        },
        // 倒计时
        countDown() {
            this.isCodeBtnDisabled = true;
            this.timer = setInterval(() => {
                this.time--;
                this.codeMsg = this.time + "s";
                if (this.time <= 0) {
                    clearInterval(this.timer);
                    this.codeMsg = "重新发送";
                    this.time = 60;
                    this.isCodeBtnDisabled = false;
                    this.codeSending = false;
                }
            }, 1000);
        },
        // 注册
        register() {
            // 验证所有字段
            if (!this.validateEmail()) {
                return;
            }
            if (!this.validateNickname()) {
                return;
            }
            if (!this.validateCode()) {
                return;
            }
            if (!this.validatePassword()) {
                return;
            }
            if (!this.validateConfirmPassword()) {
                return;
            }

            this.isLoading = true;
            const user = {
                email: this.username,
                password: this.password,
                nickname: this.nickname,
                code: this.code
            };

            emailRegister(user).then(res => {
                this.$toast({ type: "success", message: "注册成功，正在登录..." });
                // 注册成功后立即登录
                emailLogin({ email: user.email, password: user.password }).then(res => {
                    this.resetForm();
                    this.$store.commit("login", res.data);
                    this.$store.commit("closeModel");
                    this.$toast({ type: "success", message: "登录成功" });
                }).catch(err => {
                    this.isLoading = false;
                    this.$toast({ type: "warning", message: "注册成功，请手动登录" });
                });
            }).catch(err => {
                this.isLoading = false;
                this.$toast({ type: "error", message: err.message || "注册失败，请重试" });
            });
        }
    },
    computed: {
        registerFlag: {
            set(value) {
                this.$store.state.registerFlag = value;
            },
            get() {
                return this.$store.state.registerFlag;
            }
        },
        isMobile() {
            const clientWidth = document.documentElement.clientWidth;
            return clientWidth <= 960;
        },
        // 密码强度
        passwordStrength() {
            if (!this.password) return "未设置";
            let strength = 0;
            // 检查长度
            if (this.password.length >= 8) strength++;
            if (this.password.length >= 12) strength++;
            // 检查是否包含数字
            if (/\d/.test(this.password)) strength++;
            // 检查是否包含大小写字母
            if (/[a-z]/.test(this.password) && /[A-Z]/.test(this.password)) strength++;
            // 检查是否包含特殊字符
            if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password)) strength++;

            const strengthLevels = ["弱", "中等", "强", "很强", "非常强"];
            return strengthLevels[Math.min(strength, 4)];
        },
        passwordStrengthClass() {
            const strength = this.passwordStrength;
            if (strength === "弱") return "strength-weak";
            if (strength === "中等") return "strength-medium";
            if (strength === "强") return "strength-strong";
            if (strength === "很强" || strength === "非常强") return "strength-very-strong";
            return "";
        },
        // 表单是否有效
        isFormValid() {
            return this.username && 
                   this.nickname && 
                   this.code && 
                   this.password && 
                   this.confirmPassword && 
                   this.password === this.confirmPassword &&
                   this.emailErrors.length === 0 &&
                   this.passwordErrors.length === 0 &&
                   this.nicknameErrors.length === 0;
        }
    },
    beforeDestroy() {
        // 清理定时器
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
};
</script>

<style lang="scss" scoped>
.login-container {
    background-color: #fff;
    min-height: 680px;
    padding: 20px;

    .login-wrapper {
        width: 100%;
        margin: auto;
        margin-top: 10px;

        h3 {
            font-size: 24px;
            font-weight: 600;
            color: #333;
        }

        .send-wrapper {
            display: flex;
            align-items: flex-start;
            gap: 8px;

            .v-btn {
                white-space: nowrap;
                margin-top: 4px;
            }
        }

        .login-tip {
            margin-top: 20px;
            text-align: center;
            color: #666;

            span {
                color: var(--theme-color);
                cursor: pointer;
                font-weight: 500;
                transition: all 0.3s;

                &:hover {
                    opacity: 0.8;
                    text-decoration: underline;
                }
            }
        }

        .password-strength {
            font-size: 12px;
            padding-left: 12px;

            .strength-weak {
                color: #f56c6c;
            }

            .strength-medium {
                color: #e6a23c;
            }

            .strength-strong {
                color: #67c26a;
            }

            .strength-very-strong {
                color: #2196f3;
            }
        }
    }
}
</style>
